import styled from 'styled-components';
import { media } from 'theme';

export const QuestionSection = styled.div`
  padding: 16px;
  margin-bottom: 10px;
  background-color: white;
  border-radius: 4px;

  ${media.largeAndDown`
    margin-top: 11px;
  `}

  *: not(:last-child) {
    margin-bottom: 20px;
  }

  h2,
  h3 {
    font-weight: 700;
    text-align: center;
    color: ${props => props.theme.colors.neutral5};
    margin-top: 45px;
  }

  img {
    max-width: 100%;
    display: block;
    margin: 0 auto;

    ${media.ie`
      flex: none;
    `}
  }

  ul > li {
    list-style-type: circle;
    margin-bottom: 0;
  }

  ol > li {
    list-style-type: decimal;
    margin-bottom: 0;
  }

  li {
    margin-left: 30px;
    padding-bottom: 3px;
  }

  a:hover {
    text-decoration: underline;
  }

  a:link {
    color: ${props => props.theme.colors.seedlyBlue};
  }

  a:visited {
    color: ${props => props.theme.colors.seedlyBlue};
  }
`;

export const VideoWrapper = styled.div`
  display: inline-block;
  padding: 0;
  margin: 0;
  width: 100%;
  padding-top: 56%;
  height: 100%;
  position: relative;

  > iframe {
    position: absolute;
    top: 0px;
    left: 0px;
    right: 0px;
    bottom: 0px;
  }
`;

export const ProductSection = styled.div`
  margin-bottom: 11px;

  ${media.largeAndDown`
    padding: 0 15px;
  `};

  div:first-child {
    max-height: ${props => (props.shouldTruncate ? '330px' : 'auto')};
    overflow: hidden;
    position: relative;
  }

  div > * {
    margin-bottom: 14px;
  }

  h1,
  h2,
  h3 {
    font-size: 14px;
  }

  img {
    max-width: 100%;
    margin: auto;
    display: block;
    overflow: hidden;

    ${media.ie`
      flex: none;
    `}
  }

  li {
    margin-left: 50px;
    display: list-style;
    list-style-type: circle;
  }

  a:link,
  a:visited,
  a:hover,
  a:active {
    color: ${props => props.theme.colors.seedlyBlue};
  }
`;

export const ProductCategorySection = styled.div`
  padding: 16px;
  margin-bottom: 11px;
  background-color: white;
  border-radius: 4px;

  div > * {
    margin-bottom: 14px;
  }

  h1,
  h2,
  h3 {
    font-size: 14px;
  }

  img {
    max-width: 100%;
    margin: auto;
    display: block;
    overflow: hidden;

    ${media.ie`
      flex: none;
    `}
  }

  li {
    margin-left: 50px;
    display: list-style;
    list-style-type: circle;
  }

  a:link,
  a:visited,
  a:hover,
  a:active {
    color: ${props => props.theme.colors.seedlyBlue};
  }
`;

export const TruncateButton = styled.div`
  position: absolute;
  bottom: 0;
  left: 0;
  width: 100%;
  text-align: center;
  padding: 10px;
  background: white;
  color: ${props => props.theme.colors.seedlyBlue};

  &:hover {
    text-decoration: underline;
  }
`;

export const Table = styled.table`
  margin: 0 auto;

  tr {
    width: 100%;
  }

  th {
    padding: 4px;
  }

  th,
  td {
    border: 2px solid ${props => props.theme.colors.neutral4};
    text-align: center;
    padding: 12px;
    line-height: 22px;
    width: ${props => `calc(100%/${props.columnNumber})`};
    min-width: 150px;

    * {
      &:not(:last-child) {
        margin-bottom: 14px;
      }

      li {
        margin-left: 10px;
        display: list-item;
        list-style-type: circle;
        list-style-position: inside;
      }

      a:link,
      a:visited,
      a:hover,
      a:active {
        color: ${props => props.theme.colors.seedlyBlue};
      }
    }
  }

  tbody {
    tr:nth-child(odd) {
      background-color: ${props => props.theme.colors.neutral2};
    }
  }
`;

export const ProductTextSection = styled.div`
  div > * {
    margin-bottom: 14px;
  }

  h2 {
    font-size: 18px;
  }

  h3 {
    font-size: 16px;
  }

  img {
    max-width: 100%;
    margin: auto;
    display: block;
    overflow: hidden;

    ${media.ie`
      flex: none;
    `}
  }

  li {
    margin-left: 50px;
    display: list-item;
    list-style-type: circle;
  }

  a:link,
  a:visited,
  a:hover,
  a:active {
    color: ${props => props.theme.colors.seedlyBlue};
  }
`;

export const ProductTableSection = styled.div`
  text-align: center;
  margin: 12px 0px 28px;
`;

export const TableWrapper = styled.div`
  overflow-x: auto;
  border-radius: 4px;
  margin-bottom: 0;
`;

export const ProductTruncateButton = styled.span`
  display: flex;
  padding-top: 8px;
  color: ${props => props.theme.colors.seedlyBlue};
  font-weight: bold;
  font-size: 12px;
  line-height: 24px;
  cursor: pointer;

  &:hover {
    text-decoration: underline;
  }
`;

export const Title = styled.p`
  font-weight: bold;
  font-size: 18px;
  margin-bottom: 22px;

  ${media.largeAndDown`
    padding: 0 15px;
  `};
`;
